import { makeAutoObservable } from 'mobx'
import { openApi } from '../../../../helpers/request'

class importStatisticController {

    list = []

    constructor() {
        makeAutoObservable(this)
    }

    get() {
        openApi('get', '/import/history')
            .then((response) => {
                this.list = response.data ?? []
            })
            .catch((response) => {
                console.log(response.response)
            })
    }
}

export default new importStatisticController()